<rt-dropdown>
  <rt-dropdown-header>{{ 'app.wyswig.placeholders.replace_with' | translate }}</rt-dropdown-header>
  <rt-dropdown-item
    *ngFor="let placeholder of placeholders; trackBy: trackByPlaceholderId"
    [flexColumn]="true"
    (click)="emitPlaceholderChange(placeholder)"
  >
    <rt-heading variant="heading">
      <span class="preserve-whitespace" text-primary>[ </span>
      {{ withoutBrackets(placeholder.id) }}
      <span class="preserve-whitespace" text-primary> ]</span>
    </rt-heading>
    <rt-heading variant="subheading">
      <span
        [innerHTML]="placeholder.interpolated ? placeholder.value : placeholder.data.description"
      ></span>
    </rt-heading>
  </rt-dropdown-item>
  <rt-dropdown-header [uppercase]="false" (click)="emitPlaceholderDelete(active)" class="clickable">
    <rt-icon name="remove-circle" size="small-x" [isLight]="true" margin-right-small-x></rt-icon>
    {{ 'app.common.remove' | translate }}
  </rt-dropdown-header>
</rt-dropdown>
